import { getTranslation } from "./utilFunc";

export function getErrorMessage(error) {
  const { language } = require("../store").default.getState().auth;
  let msg =
    (error.response && error.response.data && error.response.data.message) ||
    (error.response && error.response.message && error.response.message) ||
    (error.response && error.response.data && error.response.data.error) ||
    (error.response &&
      error.response.data &&
      error.response.data.indication &&
      error.response.data.indication[0]) ||
    error.message ||
    error.toString();
  if (error.status && error.status === 401) {
    msg = getTranslation("Your Session Expired! Please Login Again!", language);
  }
  return msg;
}
